import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
}                                from '@angular/core';
import { BaseComponent }         from '@app/core/bases/base-component/base.component';
import {
	ISortData,
	SortOrderEnum
}                                from '@shared/list-operations/components/sort-filter/sort-filter.model';
import {
	IListOperationsConfig,
	ListOperationsEnum,
	ListOperationsIdentifierEnum,
	ListOperationsResetEnum,
	ListOperationsResetModeEnum,
	ListOperationsResetType
}                                from '@shared/list-operations/model/list-operations.model';
import { ListOperationsService } from '@shared/list-operations/services/list-operations.service';
import { Subscription }          from 'rxjs';
import {
	take,
	takeUntil
}                                from 'rxjs/operators';

@Component( {
	selector: 'app-sort',
	templateUrl: './sort.component.html',
	styleUrls: [ './sort.component.scss' ]
} )

export class SortComponent extends BaseComponent implements OnInit {

	private _listOperationIdentifier: ListOperationsIdentifierEnum;

	private _resetListOperationsSubscription: Subscription;

	private _revertSort: string;	// currently not used

	activeOperation: boolean;

	sort: string[];

	showBody: boolean;

	sortOrderEnum = SortOrderEnum;

	activeSort: string = null;

	sortOrder: SortOrderEnum;

	sortData: ISortData[];

	@Input( 'defaultSortData' )
	set defaultSortData( defaultSortData: ISortData[] ) {
		if ( defaultSortData?.length ) {
			this.sortData = [ ...defaultSortData ];
			this.setSortData();
		}
	}

	@Input( 'activeListOperationChange' )
	set activeListOperationChange( activeListOperation: ListOperationsEnum ) {
		setTimeout( () => {
			if ( activeListOperation !== ListOperationsEnum.SORT ) { this.showBody = false; }
		} );
	}

	get listOperationIdentifier(): ListOperationsIdentifierEnum {
		return this._listOperationIdentifier;
	}

	@Input( 'listOperationIdentifier' )
	set listOperationIdentifier( listOperationIdentifier: ListOperationsIdentifierEnum ) {
		if ( !listOperationIdentifier ) { return; }

		this._listOperationIdentifier = listOperationIdentifier;

		this._resetListOperationsSubscription?.unsubscribe();

		this._resetListOperationsSubscription =
			this.listOperationsService.select.resetListOperationsData(
				listOperationIdentifier,
				'SortComponent:set listOperationsIdentifier'
			)
			.pipe(
				takeUntil( this.ngUnsubscribe
				)
			)
			.subscribe( ( resetData: ListOperationsResetType ) => {
				if (
					resetData?.listOperator === ListOperationsResetEnum.ALL ||
					resetData?.listOperator === ListOperationsResetEnum.SORT
				) {
					switch ( resetData?.resetMode ) {
						case ListOperationsResetModeEnum.CLEAR:
							if ( this.sort?.length ) { this.clearControlValue(); }
							break;

						case ListOperationsResetModeEnum.DEFAULT:
						case ListOperationsResetModeEnum.RESTORE:
							this.resetFilter( resetData?.resetMode );
							break;
					}
				}
			} );
	}

	// TODO temporary flag prop to distinguish between old and new, will be removed when old has been completely replaced by new
	@Input() sidebar: boolean;

	@Output() operationChangedEmitter: EventEmitter<string> = new EventEmitter();

	@Output() operationInitializedEmitter: EventEmitter<string> = new EventEmitter();

	@Output() activeListOperationEmitter: EventEmitter<ListOperationsEnum> = new EventEmitter();

	constructor(
		private readonly listOperationsService: ListOperationsService
	) {
		super();
	}

	get prepareSortForEmit(): string {
		return this.sort ? this.sort.join( ',' ) : null;
	}


	private resetFilter( resetMode: ListOperationsResetModeEnum ): void {

		// gets configData from store
		this.listOperationsService.select.configData(
			this.listOperationIdentifier,
			'SortComponent:resetFilter'
		)
		.pipe(
			take( 1 ),
			takeUntil( this.ngUnsubscribe )
		)
		.subscribe( ( configData: IListOperationsConfig ) => {

			// sets sortData by resetMode
			switch ( resetMode ) {
				case ListOperationsResetModeEnum.DEFAULT:
					this.sortData = configData?.defaultData?.sortData ?? configData.sortData;
					break;

				case ListOperationsResetModeEnum.RESTORE:
					this.sortData = configData?.restoreData?.sortData ?? configData.sortData;
					break;
			}

			this.setSortData();
		} );
	}


	private setSortData(): void {
		this.sortOrder = this.sortOrderEnum.ASC;

		this.sortData = this.sortData ?? [];
		for ( const sortItem of this.sortData ) {
			if ( sortItem.defaultActive ) {
				if ( sortItem.sortOrder ) { this.sortOrder = sortItem.sortOrder; }
				this.setActiveSort( sortItem.name );
				this.setSort();
				break;
			}
		}

		this.emitFilterItemChange();
	}

	private emitFilterItemChange(): void {
		this.operationInitializedEmitter.emit( this.prepareSortForEmit );
	}

	private setActiveSort( activeSort: string ): void {
		this.activeSort = activeSort;
	}

	private setSort(): void {
		this.sort = null;
		if ( this.activeSort ) {
			this.sort = [];
			this.sort.push( this.activeSort );
			this.sort.push( this.sortOrder );
		}

		this.activeOperation = this.sort && this.sort.length > 0;
	}

	ngOnInit(): void {}

	resetListOperator(): void {
		this.activeOperation = false;
		this.showBody = false;
		this.setActiveSort( null );
		this.setSort();
	}

	clearControlValue(): void {
		this._revertSort = this.activeSort;	// currently not used
		this.setActiveSort( null );
		this.setSort();
		this.emitSortChanges();
	}

	// currently not used
	revertControlValue(): void {
		this.setActiveSort( this._revertSort );
		this.setSort();
		this.emitSortChanges();
	}

	toggleBodyVisibility(): void {
		this.showBody = !this.showBody;
		if ( this.showBody ) { this.activeListOperationEmitter.emit( ListOperationsEnum.SORT ); }
	}

	emitSortChanges( activeSort?: string ): void {
		if ( activeSort === this.activeSort ) { return; }
		if ( activeSort ) { this.setActiveSort( activeSort ); }
		this.setSort();

		this.operationChangedEmitter.emit( this.prepareSortForEmit );
	}

	toggleSortOrder(): void {
		this.sortOrder = this.sortOrder === this.sortOrderEnum.ASC
										 ? this.sortOrderEnum.DESC
										 : this.sortOrderEnum.ASC;

		this.emitSortChanges();
	}
}
